import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=4d8f5718&scoped=true"
import script from "./Completion.vue?vue&type=script&lang=js"
export * from "./Completion.vue?vue&type=script&lang=js"
import style0 from "./Completion.vue?vue&type=style&index=0&id=4d8f5718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f5718",
  null
  
)

export default component.exports